module.exports = __webpack_public_path__ + "img/consumer-first.81703be0.svg";